import React, { ReactElement } from 'react'
import { responsivePositioningOptions } from '@adalo/constants'
import { connect } from 'react-redux'
import { View, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'
import { RunnerObject, Screen } from 'types'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { getNodeHeight, RootPushTreeState } from 'ducks/pushTreeMap'

const { FIXED_ON_SCROLL } = responsivePositioningOptions

interface Props {
  children: ReactElement[]
  isReusableComponent: boolean
  isResponsiveComponent: boolean
  object: RunnerObject
  screenHeight: number
}

interface Context {
  getOffsetTop: () => number
}

const Wrapper = (
  {
    children,
    isReusableComponent,
    isResponsiveComponent,
    object: { id, layout: _layout, responsivity },
    screenHeight,
  }: Props,
  { getOffsetTop }: Context
): ReactElement => {
  const layout = { ..._layout }

  const { height: viewportHeight } = useWindowDimensions()

  if (isResponsiveComponent) {
    layout.height = screenHeight

    if (responsivity?.verticalPositioning === FIXED_ON_SCROLL) {
      layout.height = viewportHeight - getOffsetTop()
    }
  }

  return (
    <View style={[styles.wrapper, layout]} pointerEvents="box-none">
      {children}
    </View>
  )
}

Wrapper.contextTypes = {
  getOffsetTop: PropTypes.func,
}

const styles = StyleSheet.create({
  wrapper: {},
})

interface ConnectProps {
  isResponsiveComponent: boolean
  pushId: string
  component: Screen
}

const mapStateToProps = (
  state: RootPushTreeState,
  { component, isResponsiveComponent, pushId }: ConnectProps
): {
  screenHeight: number
} => {
  const screenHeight = isResponsiveComponent
    ? getNodeHeight(state, component.id, pushId)
    : 0

  return { screenHeight }
}

export default connect(mapStateToProps)(Wrapper)
